import { render, staticRenderFns } from "./KiwiBnc.vue?vue&type=template&id=0e092e1c&"
import script from "./KiwiBnc.vue?vue&type=script&lang=js&"
export * from "./KiwiBnc.vue?vue&type=script&lang=js&"
import style0 from "./KiwiBnc.vue?vue&type=style&index=0&id=0e092e1c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports